import React, { useState } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import { X } from 'lucide-react';
import { auth, signInWithGoogle } from '../firebase-config';
import PropTypes from 'prop-types';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

function SignIn({ onClose, isRegister, setIsRegister, isModal = false }) {
  const { signInWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
      navigate('/');
    } catch (error) {
      console.error('Sign in failed:', error);
      setError('Failed to sign in with Google');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      if (isRegister) {
        await createUserWithEmailAndPassword(auth, email, password);
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
      navigate('/');
    } catch (error) {
      setError(error.message);
    }
  };

  const formContent = (
    <>
      <h2 className="text-2xl font-bold mb-4">
        {isRegister ? 'Create Account' : 'Sign In'}
      </h2>
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
          {error}
        </div>
      )}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Email</label>
          <input
            type="email"
            className="w-full border p-2 rounded"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block mb-1">Password</label>
          <input
            type="password"
            className="w-full border p-2 rounded"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
          />
        </div>
        <div className="space-y-2">
          <button
            type="submit"
            className="w-full bg-black text-white p-2 rounded hover:bg-gray-800"
          >
            {isRegister ? 'Create Account' : 'Sign In'}
          </button>
          <button
            type="button"
            onClick={() => setIsRegister(!isRegister)}
            className="w-full text-blue-600 p-2 rounded hover:bg-blue-50"
          >
            {isRegister ? 'Sign In with Email' : 'Create Account'}
          </button>
          
          <div className="my-5 flex items-center">
            <div className="flex-grow border-t border-gray-300"></div>
            <div className="mx-4 text-gray-500">or</div>
            <div className="flex-grow border-t border-gray-300"></div>
          </div>

          <button
            type="button"
            onClick={handleGoogleSignIn}
            className="w-full bg-red-600 text-white p-2 rounded hover:bg-red-700"
          >
            Sign in with Google
          </button>
        </div>
      </form>
    </>
  );

  // If not in modal, render in a centered container
  if (!isModal) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
        <div className="bg-white p-8 rounded-lg w-96 relative">
          {formContent}
        </div>
      </div>
    );
  }

  // If in modal, just return the form content
  return formContent;
}

SignIn.propTypes = {
  onClose: PropTypes.func,
  isRegister: PropTypes.bool,
  setIsRegister: PropTypes.func,
  isModal: PropTypes.bool
};

SignIn.defaultProps = {
  onClose: () => {},
  isRegister: false,
  setIsRegister: () => {},
  isModal: false
};

export default SignIn;
